import { Card, Link as ComponentLibraryLink } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { Icon, Menu } from '@swf/sports/components';
import { ExpandablePanel } from '@swf/sports/components/ExpandablePanel/ExpandablePanel';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { useSportsLandingPageWidget } from '../../model';

import { TXTWCL_All_Competitions, TXTWCL_Competitions } from './PopularCompetitions.messages.json';
import styles from './PopularCompetitions.scss';
import CompetitionLink from './components/CompetitionLink/CompetitionLink';

const PopularCompetitions: React.FC = () => {
  const { widgetSelect } = useSportsLandingPageWidget();
  const popularCompetitions = useSelector(widgetSelect.popularCompetitions);
  const { eventTypeId, eventTypeSlug } = useSelector(select.sports.getUrlParams);

  return (
    <>
      <div className={styles.panel}>
        <ExpandablePanel
          title={
            <>
              <Icon name="trophy" size="xl" />
              <span>
                <Translation {...TXTWCL_Competitions} />
              </span>
            </>
          }
          isNested
        >
          <Menu>
            {popularCompetitions.map(({ competitionId }) => (
              <CompetitionLink key={competitionId} competitionId={competitionId} />
            ))}
          </Menu>
        </ExpandablePanel>
      </div>
      <Card padded>
        <ComponentLibraryLink variant="secondary" asChild isButtonLink>
          <Link alias="sportsCompetitions" values={{ eventTypeId, eventTypeSlug }}>
            <Translation {...TXTWCL_All_Competitions} />
            <Icon name="chevron-small-right" size="xl" />
          </Link>
        </ComponentLibraryLink>
      </Card>
    </>
  );
};

export default () => (
  <SportsComponent name="Sports Popular Competitions Component">
    <PopularCompetitions />
  </SportsComponent>
);
